import { useEffect, useState, useContext } from "react";
import SkillCard from "../skills/SkillCard";
import "./Home.css";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import Logo from "../../logo.svg"
import SpeechToText from "../speech/SpeechToText";


export default function Home() {
  const [actionEvent, setActionEvent] = useState(null);
  const { user } = useAuth();
  const { setIsOpenLogin } = useContext(AppContext)
  const navigate = useNavigate();


  // useEffect(() => {

  //   setIsOpenLogin(false)

  // }, [])

  useEffect(() => {
    if (actionEvent) {
      console.log(`actionEvent: ${JSON.stringify(actionEvent)}`);

      const { nameEvent, data } = actionEvent;
      if (nameEvent) {
        OnActionEvent(nameEvent, data);
      }
    }
  }, [actionEvent]); // importante colocar dependência

  function OnActionEvent(nameEvent, data) {
    switch (nameEvent) {
      case "skillCard":
        console.log(`skillCard: ${JSON.stringify(data)}`);
        OnSkillCard(data);
        break;
    }
  }

  function OnSkillCard(data) {
    const { route } = data;
    switch (route) {
      case "chat":
        if (user) {
          navigate("/" + route);
        } else {
          setIsOpenLogin(true)
        }
        break;
      case "games":
          navigate("/" + route);
        break;
    }

  }

  const skills = [
    // {
    //   route: "chat",
    //   name: "Real-Time Chat",
    //   description: "WhatsApp-like chat app built with WebSockets and Node.js.",
    //   cover: "/images/chat.png"
    // },
    {
      route: "games",
      name: "Games",
      description: "Jogue direto do navegador.",
      cover: "/images/games.png"
    },
    {
      route: "bot",
      name: "Bot Creator",
      description: "Coming soon...",
      cover: "/images/bot.png"
    }
  ];

return (
  <div className="home">
            
            {/* <SpeechToText /> */}
        
    <div className="logo-container">
      <img src={Logo} alt="Logo" className="logo" />
      <p className="rob-name">Unity Developer (3D/2D) | Fullstack Engineer  <br/>Game Systems, Backend and Frontend | Real-Time Applications</p>
    </div>

    <video autoPlay loop muted className="home-video">
      <source src="/videos/background.mp4" type="video/mp4" />
    </video>

    <div className="skills-grid">
      {skills.map((skill, index) => (
        <SkillCard key={index} skill={skill} setActionEvent={setActionEvent} />
      ))}
    </div>
  </div>
);

}